import { Language } from '@/models'
import { useTranslation } from 'react-i18next'
import { normalizeUiLanguage } from '@/utils/getLocale'

export default () => {
  const { i18n } = useTranslation()

  const lang = (i18n?.language
    ? normalizeUiLanguage(i18n.language)
    : 'fr') as Language

  return { lang, i18n }
}
